module.exports = __webpack_public_path__ + "img/rule-wrapper-m.af9a7f09.png";